module.exports = __webpack_public_path__ + "img/Goldy-snack.93865741.svg";